import React from 'react'
import LeftNavbar from "../HomePage/LeftNavbar";
import Footer from "../HomePage/Footer";
import LoginPage from './LoginPage';
import MouseFollower from "../HomePage/Mousefollower";

function AdminLoginIndex() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50 relative cursor-none">

      {/* Mouse Follower (already implemented by you) */}
      <MouseFollower />

      {/* Floating / Hover Left Navbar */}
      <LeftNavbar />

      {/* Main Content */}
      <main className="flex-1">
        <LoginPage />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default AdminLoginIndex
